export class PropertySubTypesController {
    constructor(axios) {
        this.axios = axios;
    }
    async find(request) {
        try {
            const response = await this.axios.get("/property-subtypes", { params: request });
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
    async detail(id) {
        try {
            const response = await this.axios.get(`/property-subtypes/${id}`);
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
}
